export const antInputModalAutoFocusWithRef = (input) =>
  setTimeout(() => {
    input && input.focus();
  }, 0);
